export const STRIPE_KEY = 'pk_live_nwa1uyr0ZYgUTMuooDcP4ScF'


// WEBPACK FOOTER //
// ./src/javascripts/config/StripeConfig.js